import { css } from 'styled-system/css';
import { Reveal } from './Reveal';

export function SectionHeader({
  eyebrow,
  title,
  align = 'left',
}: {
  eyebrow: string;
  title: string;
  align?: 'left' | 'center';
}) {
  return (
    <Reveal
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: align === 'center' ? 'center' : 'flex-start',
        textAlign: align === 'center' ? 'center' : 'left',
        gap: '4',
      })}
    >
      <span
        className={css({
          textStyle: 'eyebrow',
          fontFamily: 'sans',
          color: 'text.muted',
        })}
      >
        {eyebrow}
      </span>
      <h2
        className={css({
          fontFamily: 'sans',
          fontWeight: 'bold',
          letterSpacing: 'tight',
          lineHeight: 'tight',
          fontSize: { base: '3xl', md: '4xl' },
          color: 'text.primary',
          maxWidth: '25ch',
        })}
      >
        {title}
      </h2>
    </Reveal>
  );
}
